import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;

// Iter 710 (Kamel) — 🧖 mise en valeur du spa Oasis Park : première vidéo du site + texte, tout se règle dans l'admin (Paramètres Espagne → Spa)
export const SpaBloc = ({ compact = false }) => {
  const [spa, setSpa] = useState(null);
  const [son, setSon] = useState(false);
  const vid = useRef(null);
  useEffect(() => { axios.get(`${BASE}/api/espagne/spa`).then(r => setSpa(r.data)).catch(() => setSpa(null)); }, []);
  if (!spa || !spa.actif) return null;
  const toggleSon = () => { if (!vid.current) return; vid.current.muted = son; setSon(!son); if (vid.current.paused) vid.current.play().catch(() => {}); };
  const video = spa.video_url && (
    <div className={`relative mx-auto max-w-full ${compact ? 'w-[300px]' : 'w-[380px]'} aspect-[3/4] rounded-3xl overflow-hidden shadow-2xl ring-1 ring-white/20 bg-black lg:rotate-1 hover:rotate-0 transition-transform`} data-testid="spa-video-wrap">
      <video ref={vid} src={`${BASE}${spa.video_url}`} autoPlay muted loop playsInline controls={false} preload="metadata" className="absolute inset-0 w-full h-full object-cover" data-testid="spa-video" />
      <button type="button" onClick={toggleSon} className="absolute bottom-3 right-3 bg-white/90 hover:bg-white text-[#0F2A3F] text-xs font-bold px-4 min-h-[40px] rounded-full shadow backdrop-blur" data-testid="spa-video-son">{son ? '🔊 Son activé' : '🔇 Activer le son'}</button>
      <span className="absolute top-3 left-3 bg-[#FFC400] text-[#0F2A3F] text-[11px] font-black tracking-wider uppercase px-3 py-1 rounded-full shadow">Nouveau · en vidéo</span>
    </div>
  );
  return (
    <section className={`relative overflow-hidden rounded-3xl ${compact ? 'p-6 md:p-8' : 'p-6 md:p-10'} text-white`} style={{ background: 'linear-gradient(135deg, #0F2A3F 0%, #145C6B 60%, #1B7F8C 100%)' }} data-testid="spa-bloc">
      <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-[#79C9EA]/20 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -left-20 w-80 h-80 rounded-full bg-[#FFC400]/10 blur-3xl pointer-events-none" />
      <div className={`relative grid gap-8 items-center ${video ? 'lg:grid-cols-[1fr_auto]' : ''}`}>
        <div>
          <p className="text-[11px] font-black tracking-[0.25em] uppercase text-[#FFC400] mb-3">Hôtel Oasis Park · Espace bien-être</p>
          <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-4" data-testid="spa-titre">🧖 {spa.titre}</h2>
          <p className="text-base md:text-lg text-white/90 leading-relaxed" data-testid="spa-texte">{spa.texte}</p>
          {spa.points?.length > 0 && (
            <ul className="mt-5 flex flex-wrap gap-2" data-testid="spa-points">
              {spa.points.map((pt, i) => <li key={i} className="bg-white/10 backdrop-blur border border-white/20 rounded-full px-3.5 py-1.5 text-sm font-semibold">{i === 0 ? '💶 ' : '✓ '}{pt}</li>)}
            </ul>
          )}
          {spa.message_adultes && (
            <div className="mt-6 rounded-2xl bg-white text-[#0F2A3F] px-5 py-4 shadow-lg" data-testid="spa-message-adultes">
              <p className="text-[11px] font-black tracking-[0.2em] uppercase text-[#1B7F8C] mb-1">Un mot pour les adultes</p>
              <p className="text-sm md:text-base leading-relaxed">{spa.message_adultes}</p>
            </div>
          )}
          {spa.conclusion && (
            <div className="mt-6 border-l-4 border-[#FFC400] bg-white/10 rounded-r-2xl px-4 py-3" data-testid="spa-conclusion">
              <p className="text-sm md:text-base text-white/95 leading-relaxed italic">{spa.conclusion}</p>
            </div>
          )}
        </div>
        {video}
      </div>
    </section>
  );
};

export default SpaBloc;
